import { render } from "./ResourceYaml.vue?vue&type=template&id=144568c9&scoped=true"
import script from "./ResourceYaml.vue?vue&type=script&lang=js"
export * from "./ResourceYaml.vue?vue&type=script&lang=js"

import "./ResourceYaml.vue?vue&type=style&index=0&id=144568c9&lang=scss&scoped=true"
import "./ResourceYaml.vue?vue&type=style&index=1&id=144568c9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144568c9"]])

export default __exports__